import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import AlertIcon from "../../assets/images/alert.png";
import "../SignupPages/SignupCommon.css";

const NadPlusPage6: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");

  const options = ["Yes", "No"];

  useEffect(() => {
    const step5Completed = localStorage.getItem("completed-step-5");
    if(isSermorelinPage){
      if (step5Completed) {
        navigate("/sermorelin/getting-started/step-6", { replace: true });
      } else {
        navigate("/sermorelin/getting-started/step-5", { replace: true });
      }
    }else {
      if (step5Completed) {
        navigate("/nadplus/getting-started/step-6", { replace: true });
      } else {
        navigate("/nadplus/getting-started/step-5", { replace: true });
      }
    }
   
  }, []);

  useEffect(() => {
    const savedCheckUp = localStorage.getItem(
      "Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years"
    );
    if (savedCheckUp) {
      const parsed = JSON.parse(savedCheckUp);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);

    localStorage.setItem(
      "Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years",
      JSON.stringify({
        key: "Have_you_had_a_general_health_check_up_or_routine_physical_in_the_past_3_years",
        value: option,
      })
    );

    localStorage.setItem("completed-step-6", "true");
    if (option === "Yes") {
      setTimeout(() => {
        navigate(
          isSermorelinPage
            ? "/sermorelin/getting-started/step-7"
            : "/nadplus/getting-started/step-7"
        );
      }, 1500);
    }
  };

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-5");
    }else{
      navigate("/nadplus/getting-started/step-5");
    }
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={58} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Have you had a general health check up or routine physical in the
            past 3 years?
          </p>
          <div className="options options-box">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          {
            selectedOption === "No" && 
            <div
              className="bmi-error-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                padding: "10px",
                height: "50px",
                color: "#f8454a",
                borderRadius: "48px",
                marginTop: "20px",
              }}
            >
              <img src={AlertIcon} width="16px" height="16px" />
              <p
                className="bmi-content"
                style={{ color: "#f8454a", lineHeight: "18px" }}
              >
                It’s recommended that you have a general health check up.
              </p>
            </div> 
          }
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage6;